import request from '@/utils/request';

const baseURL = process.env.VUE_APP_SORTING;

/**
 * 新增规则
 * @param {Object} data - 规则信息
 * @param {number} data.ruleGroupId - 规则组ID
 * @param {string} data.ruleName - 规则名称
 * @param {string} data.chuteNumber - 目标格口
 * @param {number} data.priority - 优先级
 * @param {string} data.matchLogic - 匹配逻辑 (AND/OR)
 * @param {Array} data.conditions - 条件列表
 * @returns {Promise}
 */
export function addRule(data) {
  return request({
    baseURL: baseURL,
    url: '/rule/add',
    method: 'post',
    data
  });
}

/**
 * 修改规则
 * @param {Object} data - 规则信息
 * @param {number} data.id - 规则ID
 * @returns {Promise}
 */
export function updateRule(data) {
  return request({
    baseURL: baseURL,
    url: '/rule/update',
    method: 'post',
    data
  });
}

/**
 * 删除规则
 * @param {Object} params - 请求参数
 * @param {number} params.id - 规则ID
 * @returns {Promise}
 */
export function deleteRule(params) {
  return request({
    baseURL: baseURL,
    url: '/rule/delete',
    method: 'post',
    params
  });
}

/**
 * 查询规则列表
 * @param {Object} params - 查询参数
 * @param {number} params.ruleGroupId - 规则组ID
 * @returns {Promise}
 */
export function getRuleList(params) {
  return request({
    baseURL: baseURL,
    url: '/rule/list',
    method: 'get',
    params
  });
}

/**
 * 修改规则排序
 * @param {Array} data - 请求参数 [{id, priority}]
 * @returns {Promise}
 */
export function updateRulePriority(data) {
  return request({
    baseURL: baseURL,
    url: '/rule/updatePriority',
    method: 'post',
    data
  });
}

/**
 * 判断格口是否重复
 * @param {Object} params - 查询参数
 * @param {number} params.ruleGroupId - 规则组ID
 * @param {string} params.chuteNumber - 格口号
 * @param {number} [params.excludeRuleId] - 排除的规则ID
 * @returns {Promise}
 */
export function checkChuteDuplicate(params) {
  return request({
    baseURL: baseURL,
    url: '/rule/checkChuteDuplicate',
    method: 'get',
    params
  });
}

/**
 * 获取下一个优先级
 * @param {Object} params - 查询参数
 * @param {number} params.ruleGroupId - 规则组ID
 * @returns {Promise}
 */
export function getNextPriority(params) {
  return request({
    baseURL: baseURL,
    url: '/rule/nextPriority',
    method: 'get',
    params
  });
}

/**
 * 获取所有条件配置
 * @returns {Promise}
 */
export function getConditionConfigList() {
  return request({
    baseURL: baseURL,
    url: '/conditionConfig/list',
    method: 'get'
  });
}

/**
 * 获取指定条件类型配置
 * @param {Object} params - 查询参数
 * @param {string} params.conditionType - 条件类型
 * @returns {Promise}
 */
export function getConditionConfigDetail(params) {
  return request({
    baseURL: baseURL,
    url: '/conditionConfig/detail',
    method: 'get',
    params
  });
}

/**
 * 清除条件配置缓存
 * @returns {Promise}
 */
export function clearConditionConfigCache() {
  return request({
    baseURL: baseURL,
    url: '/conditionConfig/cache/clear',
    method: 'post'
  });
}

/**
 * 查询规则条件列表
 * @param {Object} params
 * @param {number} params.ruleId - 规则ID
 */
export function listConditions(params) {
  return request({
    baseURL: baseURL,
    url: '/rule/listConditions',
    method: 'get',
    params
  });
}

/**
 * 根据设备格口数量生成全量格口，已配置规则的格口标记为禁用
 * @param {Object} params
 * @param {string} params.machineCode - 分拣机编码
 * @param {number} params.ruleGroupId - 规则组ID
 */
export function listChutes(params) {
  return request({
    baseURL: baseURL,
    url: '/rule/listChutes',
    method: 'get',
    params
  });
}

/**
 * 分页查询规则变更日志
 * @param {Object} data
 * @param {number} data.pageNumber - 页码
 * @param {number} data.pageSize - 每页条数
 * @param {Object} data.params - 查询参数
 * @param {number} [data.params.ruleGroupId] - 规则组ID
 * @param {number|string} [data.params.ruleId] - 规则ID
 */
export function getRuleChangeLogPage(data) {
  return request({
    baseURL: baseURL,
    url: '/ruleChangeLog/page',
    method: 'post',
    data
  });
}

// / 分拣规则查询-新增分拣条件
export function getListRules(params) {
  return request({
    baseURL: baseURL,
    url: '/rule/listRules',
    method: 'post',
    data: params
  });
}

export function listParentRules(id) {
  return request({
    baseURL: baseURL,
    url: `/rule/listParentRules?ruleGroupId=${id}`,
    method: 'GET'
  });
}

// / 分拣机管理-分拣规则导出
export function exportRules(params) {
  return request({
    baseURL: baseURL,
    url: '/rule/exportRules',
    method: 'post',
    data: params
  });
}

// 批量导入规则
export function importRules(params) {
  return request({
    baseURL: baseURL,
    url: '/rule/import',
    method: 'post',
    data: params
  });
}
